/*jshint esversion:6 */

/**
 *@description ValidatorHelper Class to Help validate certain issues
 */
export default class ValidatorHelper {
  static StringNotEmpty(value) {
    if (value === undefined) {
      return false;
    }

    if (value === null) {
      return false;
    }

    value = value.trim();

    //Pass -> true  //Fail ->false
    //Check for Empty String
    if (!value || 0 === value.length) {
      return false;
    }

    //Check for Blank String
    if (!value || /^\s*$/.test(value)) {
      return false;
    }

    return true;
  }
  static isEmpty(source) {
    return source === null || source === undefined;
  }

  static isValidEmail(email) {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(String(email).toLowerCase());
  }
}



// WEBPACK FOOTER //
// ./src/components/common/validatorhelpers.js